import {Component, OnInit} from '@angular/core';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {Standard} from '../../../../models/standard.model';
import * as moment from 'moment';
import {Response} from '@angular/http';
import {MessageService} from '../../../operating-standard/chat/message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-opst-step-three',
  templateUrl: './opst-step-three.component.html',
  styleUrls: ['./opst-step-three.component.css']
})
export class OpstStepThreeComponent implements OnInit {
  thisStandard: any;
  usersAndGroups: any;
  stringDate: string;
  acknowledgementDays = 5;
  acknowledgementDaysTemp = null;
  showDiscussionBtn = false;
  showTable = false;
  isReadOnly = false;
  showAllowToFiveStep = false;
  showAllowToFourStep = false;
  goBtnIsClicked = false;
  isLoaded = false;
  isLoadedStep = false;
  tableUsers: any;
  showNewChat = false;
  showChat = true;
  showUserTable = false;

  constructor(public stepsControllerService: StepsControllerService,
              private messageService: MessageService,
              private router: Router) {
  }

  ngOnInit() {
    this.stepsControllerService.setNotifyType('');
    this.isLoadedStep = false;
    this.showDiscussionBtn = false;
    this.stringDate = moment().format('DD.MM.YYYY');

    this.stepsControllerService.updateCurrentStandartFromApi().subscribe(
      (response: any) => {
        this.stepsControllerService.setCurrentStandard(response.body);
        // При входе сюда, устанавливать в сервисе текущий стандарт из листа стандартов.
        if (this.stepsControllerService.getCurrentStandard()) {
          this.thisStandard = this.stepsControllerService.getCurrentStandard();
          if (this.thisStandard.status === 'UNDER_CONFIRMATION') {
            this.isReadOnly = true;
            this.acknowledgementDays = this.thisStandard.daysForAcknowledgement;
            this.acknowledgementDaysTemp = this.thisStandard.daysForAcknowledgement;
            this.getUserTable();
          }
          if (this.thisStandard.status === 'NEW') {
            this.showDiscussionBtn = true;
            this.showNewChat = false;
          } else {
            this.showNewChat = true;
          }
          this.isLoadedStep = true;
        } else {
          this.thisStandard = null;
          this.isReadOnly = false;
          this.isLoadedStep = true;
        }
      },
      () => {
        this.isLoadedStep = true;
      }
    );
  }

  checkInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode < 48 || charCode > 57) {
      return false;
    } else if (charCode === 48) {
      if (this.acknowledgementDays.toString().length === 0) {
        this.acknowledgementDays = 1;
        return false;
      }
    } else if (this.acknowledgementDays.toString().length === 3) {
      return false;
    }

    return true;
  }

  onChange() {
    // this.showDiscussionBtn = this.acknowledgementDaysTemp !== this.acknowledgementDays;
    if (this.acknowledgementDays < 1) {
      this.acknowledgementDays = 1;
    }
  }

  goToDiscussion() {
    this.goBtnIsClicked = true;
    this.stepsControllerService.goToDiscussion(this.acknowledgementDays).subscribe(
      (response) => {
        if (response.status === 200) {
          this.showDiscussionBtn = false;
          this.isReadOnly = true;
          this.stepsControllerService.setCurrentStandard(response.body);
          this.showNewChat = true;
          this.getUserTable();
          this.goBtnIsClicked = false;
          this.messageService.setSshowInputBlock(true);
        }
      },
      () => {
        this.goBtnIsClicked = false;
      }
    );
  }

  getUserTable() {
    this.isLoaded = false;
    this.stepsControllerService.getConfirmatoriesInfo(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.showDiscussionBtn = false;

          if (this.tableUsers.length > 0) {
            this.showTable = true;
          }
          this.thisStandard.status = this.stepsControllerService.getCurrentStandard().status.toString();

          // Проверка для Шага 4
          if (this.thisStandard.needModifications) {
            this.stepsControllerService.stepFourDisabled = false;
            this.showAllowToFiveStep = false;
            this.showAllowToFourStep = true;
            this.stepsControllerService.stepFiveDisabled = true;
            this.stepsControllerService.activeStep = 4;
            this.router.navigate(['/dashboard/create-operating-standard/step-four']);
            this.stepsControllerService.stepThreeDisabled = true;
          } else {
            this.stepsControllerService.stepFourDisabled = true;
            this.showAllowToFourStep = false;
          }

          // Проверка для Шага 5
          if (this.thisStandard.readyForFamiliarizationStage) {
            this.stepsControllerService.stepFourDisabled = true;
            this.stepsControllerService.stepFiveDisabled = false;
            this.stepsControllerService.stepThreeDisabled = true;
            this.stepsControllerService.activeStep = 5;
            this.router.navigate(['/dashboard/create-operating-standard/step-five']);
            this.showAllowToFiveStep = true;
            this.showAllowToFourStep = false;
          }
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  shBlock(s) {
    switch (s) {
      case 'sc':
        this.showChat = !this.showChat;
        break;
      case 'sut':
        this.showUserTable = !this.showUserTable;
        break;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-three/opst-step-three.component.ts